import { Component, Input, OnInit } from '@angular/core';
import { ConnectivityCatalogType } from 'src/app/domains/connectivity/models/connectivity.model';
@Component({
  selector: 'gdp-connectivity-entry-type',
  templateUrl: './connectivity-entry-type.component.html'
})
export class ConnectivityEntryTypeComponent implements OnInit {
  @Input() type: ConnectivityCatalogType;
  public ConnectivityCatalogType = ConnectivityCatalogType;

  constructor() { }

  ngOnInit(): void {
  }
  
}